import React from "react";
import FormField from "./FormField";

/**
 *
 * @param {TextField.defaultProps} props
 * @returns
 */
const TextField = (props) => {
  return <FormField {...props} />;
};

TextField.defaultProps = {
  ...FormField.defaultProps,
  type: "text",
};

export default TextField;
